import { useAssetIcon } from '@blink/assets';
import React, { FC } from 'react';

type AssetIconProps = React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
> & {
    assetName: string;
    className?: string;
};

const LPBadge: FC = () => (
    <div
        className='absolute bottom-0 left-0 px-[5px] py-[1px] inline-flex justify-center items-center gap-[5px]'
        style={{
            borderRadius: '160px',
            border: '0.5px solid rgba(255, 255, 255, 0.20)',
            background:
                'linear-gradient(180deg, rgba(71, 50, 212, 0.40) 0%, rgba(71, 50, 212, 0.08) 100%)',
            backdropFilter: 'blur(2px)',
            color: '#FFF',
            fontFamily: 'Inter',
            fontSize: '8px',
            fontStyle: 'italic',
            fontWeight: 700,
            lineHeight: '10px',
            letterSpacing: '-0.075px',
            textTransform: 'uppercase',
        }}
    >
        LP
    </div>
);

export const AssetIcon: FC<AssetIconProps> = ({ assetName, className = '', ...props }) => {
    const upperAssetName = assetName?.toUpperCase();
    const icon = useAssetIcon(upperAssetName);
    const isLP = upperAssetName?.startsWith('LP-');
    const imgClass = `h-8 w-8 rounded-full object-cover ${className}`;

    if (!icon) {
        return <div className={imgClass.replace('object-cover', 'bg-gray-200')} />;
    }

    return isLP ? (
        <div className={`relative h-8 w-8 ${className}`}>
            <img
                className='h-8 w-8 rounded-full object-cover'
                src={icon}
                alt={assetName}
                {...props}
            />
            <LPBadge />
        </div>
    ) : (
        <img className={imgClass} src={icon} alt={assetName} {...props} />
    );
};
